<div class="row">
    <div class="col-md-12">
        <mat-card >
            <mat-card-content style="height: 40vh;">
                <div id="chart"></div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<br>
<div class="row">
<div class="col-md-6">
    <mat-card>
        <mat-card-header class="alert-text">Reasons for Higher Oil Temperature</mat-card-header>
        <mat-card-content>
            <hr>
            <ul>
                <li *ngFor="let msg of messages">{{ msg }}</li>
              </ul>
        </mat-card-content>
    </mat-card>
</div>
</div>
